<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 18" fill="none" stroke="currentColor">
        <path d="M0.888916 3.82353H15.1111M5.33336 1H10.6667M11.1111 17H4.88892C3.90708 17 3.11114 16.1572 3.11114 15.1176L2.70527 4.80389C2.68423 4.26918 3.08795 3.82353 3.59339 3.82353H12.4067C12.9121 3.82353 13.3158 4.26918 13.2948 4.80389L12.8889 15.1176C12.8889 16.1572 12.093 17 11.1111 17Z" stroke-width="1.5" stroke-linecap="round"/>
    </svg>
</template>